import React from "react";
import { Link } from "react-router-dom";

import { useAppMeta, useAuth } from "hooks";

const AppLogo = ({ hideEntity = false }) => {
  const { viewEntity } = useAuth();

  const _entityName = viewEntity?.entity?.name;

  const { appMeta } = useAppMeta();

  return (
    <Link to="/app" className="relative flex-grow py-2">
      <div className="-ml-[1px] text-lg font-medium line-clamp-1">
        {appMeta?.title ?? "CAN TMS"}
      </div>

      {!hideEntity && (
        <div className="flex-wrap text-[10px] font-medium tracking-wider text-blue-600 dark:text-blue-200">
          {_entityName}
        </div>
      )}
    </Link>
  );
};

export default AppLogo;
